import React, { useContext } from 'react';
import { Col, Flex, Box, Title, Text, Row } from '@firsttable/web-components/atoms';
import { ContainerContent, RowHead } from '@firsttable/web-components/molecules';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import imgBird from '../organisms/ContactUs/bird.svg?url';
import ContactForm from '../organisms/Forms/DynamicUserForm';
import imgFork from '../organisms/ContactUs/fork.svg?url';
import parseHtml from '../../lib/parseHtml';
import SEO from '../SEO';
import SilverstripeContext from '../context/Silverstripe';

const ContactUs = () => {
  const { page } = useContext(SilverstripeContext);
  return (
    <TrackProvider pageEventName="account_viewed" source_page="contact us">
      <ContainerContent>
        <SEO
          id={page.id}
          title={page.metaTitleFormatted}
          description={page.metaTitleFormatted}
          ogImage={page.ogImage}
          metaTags={page.metaTags}
          slug={page.slug}
        />
        <RowHead>
          <Col display="flex" justifyContent="center">
            <Flex>
              <Box
                position="relative"
                top="9px"
                left="-25px"
                width="72px"
                ml="-72px"
                display={['none', 'block']}>
                <img src={imgBird} alt="" />
              </Box>
              <Box>
                <Title as="h1" size="h1" m="0 0 16px">
                  Contact us
                </Title>
                <Text letterSpacing="-0.5px" fontSize="xl">
                  Get in touch - we love hearing from you!
                </Text>
              </Box>
            </Flex>
          </Col>
        </RowHead>
        <Row gap={[null, 120, 164]}>
          <Col width={[1, 1 / 2]}>
            <ContactForm
              id="ContactForm"
              formData={page.userForm}
              formFields={page.userForm.formFields}
              data-testid="contact__form"
            />
          </Col>
          <Col width={[1, 1 / 2]} line mt={[null, 20]} icon={imgFork}>
            <Title as="h3" size="h3" mb="0">
              First Table
            </Title>
            <Title color="gold.900" size="h6" as="div" m="0 0 31px">
              Limited
            </Title>
            {parseHtml(page.sidebarContent)}
          </Col>
        </Row>
      </ContainerContent>
    </TrackProvider>
  );
};

export default ContactUs;
